import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSchoolHeadPeriod } from "@/contexts/SchoolHeadPeriodContext";
import { Calendar } from "lucide-react";

export function PeriodSelector({ allowAllTerms = true }: { allowAllTerms?: boolean }) {
  const {
    years,
    selectedYearId,
    setSelectedYearId,
    selectedTermId,
    setSelectedTermId,
    selectedYear,
  } = useSchoolHeadPeriod();

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border bg-muted/30 p-3">
      <Calendar className="h-4 w-4 text-muted-foreground" />
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">Academic Year:</span>
        <Select value={selectedYearId || ""} onValueChange={setSelectedYearId}>
          <SelectTrigger className="h-9 w-[200px]">
            <SelectValue placeholder="Select year" />
          </SelectTrigger>
          <SelectContent>
            {years.map((y) => (
              <SelectItem key={y.id} value={y.id}>
                {y.name} {y.is_active ? "(Active)" : ""}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">Term:</span>
        <Select
          value={selectedTermId || "__all__"}
          onValueChange={(v) => setSelectedTermId(v === "__all__" ? null : v)}
        >
          <SelectTrigger className="h-9 w-[200px]">
            <SelectValue placeholder="Select term" />
          </SelectTrigger>
          <SelectContent>
            {allowAllTerms && <SelectItem value="__all__">All terms (whole year)</SelectItem>}
            {selectedYear?.terms
              ?.slice()
              .sort((a, b) => a.start_date.localeCompare(b.start_date))
              .map((t) => (
                <SelectItem key={t.id} value={t.id}>
                  {t.name} {t.is_active ? "(Active)" : ""}
                </SelectItem>
              ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
